module.exports = __webpack_public_path__ + "static/media/fruits_34.378f5223.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_34.csv
// module id = 700
// module chunks = 0